var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInsurance(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.3,
    height: 33.991,
    viewBox: "0 0 31.3 33.991",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 7873",
    d: "M17.75 35.092a2.774 2.774 0 0 1-1.352-.353l-5.358-2.976a17.1 17.1 0 0 1-8.79-14.939v-8.26A2.777 2.777 0 0 1 4.743 5.8a27.507 27.507 0 0 0 6.25-1.413 27.548 27.548 0 0 0 5.3-2.54 2.784 2.784 0 0 1 2.906 0 27.591 27.591 0 0 0 5.3 2.539A27.507 27.507 0 0 0 30.757 5.8a2.777 2.777 0 0 1 2.493 2.764v8.26a17.1 17.1 0 0 1-8.79 14.939L19.1 34.74a2.771 2.771 0 0 1-1.351.352zm0-31.272a.38.38 0 0 0-.2.055 29.987 29.987 0 0 1-5.763 2.759A29.84 29.84 0 0 1 4.995 8.17a.394.394 0 0 0-.36.394v8.26A14.713 14.713 0 0 0 12.2 29.678l5.359 2.977a.392.392 0 0 0 .383 0l5.358-2.977a14.713 14.713 0 0 0 7.564-12.854v-8.26a.394.394 0 0 0-.36-.394 29.841 29.841 0 0 1-6.794-1.535 29.987 29.987 0 0 1-5.763-2.759.373.373 0 0 0-.2-.056z",
    transform: "translate(-2.1 -1.251)",
    style: {
      fill: "currentColor",
      stroke: "var(--sidebar-surface)",
      strokeWidth: ".3px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 7874",
    d: "M14.187 19.177a1.414 1.414 0 0 1-.944-.359l-4.265-3.792a1.422 1.422 0 1 1 1.888-2.126l3.234 2.872L20.26 9.2a1.422 1.422 0 1 1 2.074 1.946l-7.11 7.583a1.417 1.417 0 0 1-1.037.449z",
    transform: "translate(.39 2.275)",
    style: {
      fill: "currentColor",
      stroke: "var(--sidebar-surface)",
      strokeWidth: ".3px"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsurance);
export default __webpack_public_path__ + "static/media/insurance.d8b61ce5995637a6fec216e95b1bd86e.svg";
export { ForwardRef as ReactComponent };